import { Box, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(({ spacing }) => ({
  topCircle: {
    border: "40px solid #e5e5e5",
    borderRadius: "50%",
    width: "300px",
    height: "300px",
  },
  leftCircle: {
    border: "40px solid #e5e5e5",
    borderRadius: "50%",
    width: "300px",
    height: "300px",
    position: "absolute",
    zIndex: -1,
    left: "-13em"
  },
  rightCircle: {
    border: "40px solid #e5e5e5",
    borderRadius: "50%",
    width: "356px",
    height: "356px",
    position: "absolute",
    top: "2em",
    right: "-5em",
    zIndex: -1,
  },
  fullCircle: {
    borderRadius: "50%",
    height: "300px",
    width: "300px",
    backgroundColor: "#e5e5e5",
    position: "absolute",
    zIndex: -1,
    left: "35%",
  },
}));

const Circle = (props) => {

  const classes = useStyles()

  return <Box className={props.circleClass === "fullCircle" ? classes.fullCircle : props.circleClass === "topCircle" ? classes.topCircle : props.circleClass === "leftCircle" ? classes.leftCircle : classes.rightCircle}></Box>
};

export default Circle;